import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getAdditionalProps } from '@eventbrite/legacy-eds.utils/props';
import { onClickOutsideHOC } from '@eventbrite/legacy-eds.utils/click';
import { ALIGN_PROP_TYPE, ALIGN_FULL } from './constants';

import styles from './Dropdown.module.scss';

/**
 * A Dropdown is a simple component that contains arbitrary content. It is intended to be used as the dropdown for AutocompleteField or DropdownMenu.
 */
export class DropdownSimple extends React.PureComponent {
    static propTypes = {
        /**
         * Contents of the dropdown
         */
        children: PropTypes.node.isRequired,

        /**
         * How the dropdown should be horizontally positioned relative its container
         */
        align: ALIGN_PROP_TYPE,

        /**
         * Whether or not the dropdown should "drop up"
         */
        dropUp: PropTypes.bool,

        /**
         * Callback triggered by clicking outside of the dropdown
         */
        onClickOutside: PropTypes.func,
    };

    static defaultProps = {
        align: ALIGN_FULL,
        dropUp: false,
    };

    render() {
        const { children, align, dropUp } = this.props;
        const className = classNames(
            styles.root,
            styles.fadeIn,
            styles[`align-${align}`],
            dropUp ? styles.dropUp : styles.dropDown,
        );

        const extraAttrs = getAdditionalProps(this);

        return (
            <div {...extraAttrs} className={className} data-testid="dropdown">
                {children}
            </div>
        );
    }
}

export const Dropdown = onClickOutsideHOC(DropdownSimple);
